// extracted by mini-css-extract-plugin
export var dateLabel = "_2o-0";
export var dateLabelError = "_2o-1";
export var fullWidth = "_2o-2";
export var smaller = "_2o-3";